module.exports = __webpack_public_path__ + "img/arrow_select_02.c5c3fad1.svg";